import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CveList' })({
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 36,
        paddingBottom: 36
    },
    title: {
        marginBottom: 24
    },
    breadcrumbs: {
        marginBottom: 24,
        marginLeft: 4
    }
});
